import { IdKeyedObjectShape } from 'contexts/base'
import { IdentifiableModel } from 'cs-kevlar-react/lib/es/base'

const EMPTY_ARRAY: any[] = []

type IdKeyedObject<TType> = undefined | null | IdKeyedObjectShape<TType>

export const idObjectToArray = <TType extends {}>(
  obj: IdKeyedObject<TType>,
) => {
  if (!obj) return EMPTY_ARRAY

  return Object.keys(obj).map(id => obj[id])
}

export const matchIdOrDefault = <TType extends {}>(
  items: IdKeyedObjectShape<TType> | undefined,
  id: string | undefined,
  defaultItem: TType,
) => {
  let matchedItem: TType | null = null
  if (id && id === 'NEW') {
    matchedItem = defaultItem
  } else if (id && id !== 'NEW' && typeof items?.[id] !== 'undefined') {
    matchedItem = items?.[id]
  }

  return matchedItem
}

export const matchIdOrDefaultWithBulk = <TType extends {}>(
  items: IdKeyedObjectShape<TType> | undefined,
  id: string | undefined,
  defaultItem: TType,
  bulkItem: TType
) => {
  let matchedItem: TType | null = null
  if (id && id === 'NEW')
    matchedItem = defaultItem
  else if (id && id === 'BULK')
    matchedItem = bulkItem
  else if (id && id !== 'NEW' && id !== 'BULK' && typeof items?.[id] !== 'undefined')
    matchedItem = items?.[id]

  return matchedItem
}

export const asIdentifiable = <TType>(
  value: TType,
  id: string,
): TType & IdentifiableModel => {
  return {
    ...value,
    id: id,
  }
}
